import React from 'react';
import { Link } from 'react-router-dom';
import destinationsEn from '../../data/destinationsData';
import destinationsTh from '../../data/destinationData.th';
import '../Destination/style.css';
import { useTranslation } from 'react-i18next';

const Destination2 = () => {
  const { t, i18n } = useTranslation();

  // Select data based on current locale
  const destinations = i18n.language === 'th' ? destinationsTh : destinationsEn;

  const getOrigin = (title) => {
    if (!title || typeof title !== 'string') {
      console.error(`Invalid title format: ${title}`);
      return t('unknown_destination');
    }
    if (!title.includes('↔')) {
      console.warn(`Title does not contain the expected separator: ${title}`);
      return title.trim();
    }
    const origin = title.split('↔')[0].trim();
    return t(`origins.${origin}`) || origin;
  };

  const generateId = (str) => {
    // Use English names for IDs to ensure consistency across locales
    const englishName = allowedOrigins.find(origin => 
      t(`origins.${origin}`) === str
    ) || str;
    
    return englishName
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^\w-]+/g, '')
      .replace(/--+/g, '-')
      .replace(/^-+/, '')
      .replace(/-+$/, '');
  };

  // Filter destinations for only Bangkok and Phuket origins
  const allowedOrigins = ['Bangkok', 'Phuket', 'Chiang Mai', 'Krabi'];
  const filteredDestinations = destinations.filter((dest) => {
    const origin = getOrigin(dest.Title);
    return allowedOrigins.some(allowed => t(`origins.${allowed}`) === origin);
  });

  const groupDestinations = (destinations) => {
    return destinations.reduce((acc, dest) => {
      if (!dest || !dest.Title) {
        console.warn('Skipping destination with invalid data:', dest);
        return acc;
      }
      const origin = getOrigin(dest.Title);
      // Find the English name for the current origin
      const englishOrigin = allowedOrigins.find(allowed => 
        t(`origins.${allowed}`) === origin
      ) || origin;
      
      if (!acc[origin]) {
        acc[origin] = {
          translatedName: origin,
          englishName: englishOrigin,
          destinations: []
        };
      }
      acc[origin].destinations.push(dest);
      return acc;
    }, {});
  };

  const groupedDestinations = groupDestinations(filteredDestinations);
  const originCities = Object.keys(groupedDestinations);

  return (
    <div className="destination-area optimize-visibility">
      <div className="container">
        <div className="wpo-section-title">
          <h2>{t('choose_your_favorite')}</h2>
          <div className="destination-menu">
            <div className="link-grid">
              {originCities.map((origin, index) => (
                <Link 
                  key={index} 
                  to={`#${generateId(groupedDestinations[origin].englishName)}`}
                  className="location-link"
                  onClick={(e) => {
                    e.preventDefault();
                    const element = document.getElementById(generateId(groupedDestinations[origin].englishName));
                    if (element) {
                      element.scrollIntoView({ behavior: 'smooth' });
                    }
                  }}
                >
                  {groupedDestinations[origin].translatedName}
                </Link>
              ))}
            </div>
          </div>
        </div>

        {originCities.map((origin, groupIndex) => (
          <div key={groupIndex} id={generateId(groupedDestinations[origin].englishName)}>
            <div className="wpo-section-title">
              <h2>{groupedDestinations[origin].translatedName}</h2>
            </div>
            <div className="row">
              {groupedDestinations[origin].destinations.map((dest, index) => (
                <div className="col-6 col-md-4 col-lg-3" key={index}>
                  <a
                    href={dest.link}  // Use dest.link directly without translation
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  >
                    <div className="destination-item">
                      <div className="destination-img">
                        <img
                          src={dest.DImg || 'default-placeholder.webp'}
                          alt={t(dest.Title) || t('destination')}
                          loading="lazy"
                        />
                      </div>
                      <div className="destination-content">
                        <div className="content-left">
                          <h5>{t(dest.Title) || t('unknown_destination')}</h5>
                          <small>{dest.Date ? t('routes.Daily') : t('unknown_date')}</small>
                        </div>
                        <div className="content-right">
                          <h5>{dest.price || 'N/A'}</h5>
                          <span>{t('starting')}</span>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              ))}
            </div>
          </div>
        ))}
        
        <div className="btns text-center">
          <Link to="/destination2" className="theme-btn-s2" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            {t('discover_more')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Destination2;
